import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule as CoachBotSharedModule } from '@app/shared/shared.module';
import { DashboardUiModule } from '@dashboard/ui';
import { MainHeaderComponent } from './components';
import { StudentFacade } from './facades';
import { NotificationsService, SessionStorageCacheService } from './services';
import { StudentState } from './states';

const SHARED_MODULES = [
  DashboardUiModule
];

const SHARED_COMPONENTS = [
  MainHeaderComponent
];

const SHARED_SERVICES = [NotificationsService, SessionStorageCacheService, StudentFacade, StudentState];

@NgModule({
  imports: [...SHARED_MODULES, CoachBotSharedModule, CommonModule],
  declarations: [...SHARED_COMPONENTS],
  providers: [...SHARED_SERVICES],
  exports: [...SHARED_MODULES, ...SHARED_COMPONENTS, CoachBotSharedModule],
})
export class SharedModule {}
